// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.Access.js" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

import React from 'react';

import connect from 'share/enhancers/Izenda.Connect';
import Panel from 'share/components/controls/Izenda.Panel';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import RightPanelContent from './Izenda.RightPanelContent';
import Header from './Izenda.Header';
import constants from 'logic/data/Izenda.PermissionConstants';

const Access = connect()(props => {
  const { model, localization } = props;

  const header = {
    component: Header,
    headerName: localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_HEADER_NAME_ACCESS'),
    model
  };
  return (
    <Panel
      className='u_fullHeight u_noMarginAll u_noBorder '
      header={header}
      collapsible
      expanedOption={model.collapseAll}
    >
      <GridLayout>
        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue izenda-Permission-LargeRow'>
            <GridLayout.Col cols='3' className='grid-small-column u_borderRight u-bgWhite'>
              <div>
                <span className='u_smallIcon u_alignMiddle'>&#9899;</span>
                <span>{localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_ACCESS_LIMITS')}</span>
              </div>
            </GridLayout.Col>
            <RightPanelContent
              model={model}
              keysPath='access.accessLimits.value'
              isParent
              showRole
              notShowBlankCharacter
              treeType={constants.TREE_TYPE.ACCESS}
              popupTitle={localization.getText('PERMISSION_LABEL_ACCESS_LIMITS')}
              popupMessage={localization.getText(
                'ROLE_SETUP_PERMISSION_SUMMARY_ROLE_CATEGORY_SUBCATEGORY_ACCESS_LIMIT'
              )}
            />
          </GridLayout.Col>
        </GridLayout.Row>

        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className='grid-small-column u_borderRight u-bgWhite'>
              <div>
                <span className='u_smallIcon u_alignMiddle'>&#9899;</span>
                <span>{localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_ACCESS_DEFAULT')}</span>
              </div>
            </GridLayout.Col>
            <RightPanelContent
              model={model}
              keysPath='access.accessDefaults.value'
              isParent
              showRole
              isAccessDefault
              notShowBlankCharacter
              treeType={constants.TREE_TYPE.ACCESS}
              popupTitle={localization.getText('PERMISSION_LABEL_ACCESS_DEFAULT')}
              popupMessage={localization.getText(
                'ROLE_SETUP_PERMISSION_SUMMARY_ROLE_CATEGORY_SUBCATEGORY_ACCESS_DEFAULT'
              )}
            />
          </GridLayout.Col>
        </GridLayout.Row>
      </GridLayout>
    </Panel>
  );
});

export default Access;



// WEBPACK FOOTER //
// ./ui/modules/Settings/RoleSetup/RoleDetail/PermissionSummary/Izenda.Access.js